import { Input } from '@components/Input'
import styled from '@emotion/styled'
import { BackdropModal } from '@helpers/styles'
import { Divider as MuiDivider } from '@mui/material'

const BackdropWithModalStyles = styled(BackdropModal)`
	.add-product-section-title {
		color: #cdcdcd;
		font-size: 1rem;
	}

	.add-product-form-label {
		color: #6f6f6f;
		font-size: 0.875rem;
	}

	.add-product-form-input {
		margin-bottom: 16px;
	}

	.add-product-modal-action-part {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		padding-top: 12px;

		.add-product-modal-cancel-button {
			margin-right: 10px;
		}
	}
	.invite-supplier-button {
		width: 190px;
	}
`

const Divider = styled(MuiDivider)`
	${({ theme }) => `
		background: ${theme.palette.borderColors.lightGrey};
	`}
`

const ModalInput = styled(Input)`
	width: 280px;
	flex: 1;
	padding: 0;
`

export { BackdropWithModalStyles, Divider, ModalInput }
